import api from "./Api";

class TabelaNBSService {
  GetTabelaNBS(payload) {
    return api.get("/v1/tabelaNBS/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTabelaNBS(payload) {
    return api.post("/v1/tabelaNBS/", payload).then((response) => {
      return response.data;
    });
  }

  PutTabelaNBS(payload) {
    return api.put("/v1/tabelaNBS/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTabelaNBS(payload) {
    return api.delete("/v1/tabelaNBS/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTabelaNBSOData(payload) {
    return api.get("/OData/TabelaNBS" + payload).then((response) => {
      return response.data;
    });
  }

  AtualizarTabelaNBS(payload) {
    return api
      .post("/v1/tabelaNBS/AtualizarTabelaNBS", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new TabelaNBSService();
